type RoofPoint = [number, number, number];

export interface RoofBody {
  x: number; y: number; z: number;
  w: number; d: number; h: number;
}

export interface RoofGeometry {
  /** Canonical coordinates: x crosses the gable; y follows the ridge. */
  x: number; y: number; w: number; d: number; z: number;
  rise: number;
  alongX: boolean;
  farVisible: boolean;
  /** Convert a canonical roof vertex back to the building's world axes. */
  point(v: RoofPoint): RoofPoint;
}

/** A pitched roof seated on the body's top, with its ridge on the long axis. */
export function roofGeometry(b: RoofBody, pitch: number, eave: number): RoofGeometry {
  const alongX = b.w > b.d * 1.15;
  const over = Math.min(b.w, b.d) * (0.095 + 0.05 * eave);
  const w = (alongX ? b.d : b.w) + over * 2;
  const d = (alongX ? b.w : b.d) + over * 2;
  const rise = w * 0.5 * Math.max(0.5, Math.min(1.65, 0.35 + 0.76 * pitch));
  return {
    x: (alongX ? b.y : b.x) - over,
    y: (alongX ? b.x : b.y) - over,
    w, d, z: b.z + b.h, rise, alongX,
    // The far roof plane turns away from the 2:1 ground projection above
    // this slope; its decoration must be culled along with the plane.
    farVisible: rise * Math.sqrt(1.5) < w * 0.5,
    point: alongX ? ([x, y, z]) => [y, x, z] : ([x, y, z]) => [x, y, z],
  };
}
